import { RouteDataService } from './route-data.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';

import { throwError as observableThrowError, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { NotificationService } from './notification.service'

import { LoginInfoProvider } from '../ev-dal/login-info.provider';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class CommonRequestResponseService {
  partnerId: any;
  loginDetail;
  userId = new Subject();
  completeUrl = '';
  notificationCount = 0;
  currentUrl: any;
  errorMessage: string;
  headers: HttpHeaders;

  constructor(
    private loginInfoProvider: LoginInfoProvider,
    private http: HttpClient,
    private notificationService: NotificationService,
    private _commonDataSharedService: CommonDataSharedService,
    private _routeDataService: RouteDataService
  ) {
    this.currentUrl = window.location.hostname === 'localhost' ? 'http://envision-test-caa.issportals.com/api' : `${window.location.origin}/api`;
    this._commonDataSharedService.partnerId.subscribe((partnerId: number) => {
      this.partnerId = partnerId;
    });
  }

  postForThirdParty(url, inputData) {
    this.notificationCount++;
    inputData = this.setUserDetailAPI(inputData);
    this.completeUrl = url;
    return this.http.post(this.completeUrl, inputData).pipe(catchError((err: HttpErrorResponse) => this.catchError(err)));
  }

  post(url, inputData) {
    this.notificationCount++;
    inputData = this.setUserDetailAPI(inputData);
    this.completeUrl = `${this.currentUrl}/api/` + url;

    return this.http.post(this.completeUrl, inputData).pipe(catchError((err: HttpErrorResponse) => this.catchError(err)));
  }

  getCountData() {
    return this.post('shared/get/counts', { userRoleData: this.loginDetail['role'] });
  }

  delete(url, inputData) {
    this.notificationCount++;
    inputData = this.setUserDetailAPI(inputData);
    this.completeUrl = `${this.currentUrl}/api/` + url;
    const requestbody = { headers: this.headers, body: inputData };
    return this.http.delete(this.completeUrl, requestbody).pipe(catchError((err: HttpErrorResponse) => this.catchError(err)));
  }

  postWithHeader(url, inputData, defaultParam = []) {
    this.notificationCount++;
    inputData = this.setUserDetailAPI(inputData, defaultParam);
    const completeUrl = `${this.currentUrl}/api/` + url;

    return this.http.post(completeUrl, inputData).pipe(catchError((err: HttpErrorResponse) => this.catchError(err)));
  }

  postWithStaticHeaderData(url, inputData) {
    this.notificationCount++;
    inputData = this.setUserDetailAPI(inputData);
    this.completeUrl = `${this.currentUrl}/api/` + url;

    return this.http.post(this.completeUrl, inputData).pipe(catchError((err: HttpErrorResponse) => this.catchError(err)));
  }

  putWithHeader(url, inputData, defaultParam = []) {
    this.notificationCount++;
    inputData = this.setUserDetailAPI(inputData, defaultParam);
    this.completeUrl = `${this.currentUrl}/api/` + url;

    return this.http.put(this.completeUrl, inputData).pipe(catchError((err: HttpErrorResponse) => this.catchError(err)));
  }

  checkAndGetLoginDetail() {
    this.loginDetail = this.loginInfoProvider.loginInfo;
    if (this.loginDetail && Object.keys(this.loginDetail).length > 0) {
      return this.loginDetail;
    }

    if (this.loginDetail) {
      return this.loginDetail;
    }

    if (this.notificationCount === 0) {
      this._routeDataService.unAuthorized.next(true);
    }
  }

  checkAndInsertDetail(key, object, newData, defaultParam = []) {

    if (defaultParam.indexOf(key) === -1) {
      object[key] = newData;
    }

    return object;
  };

  setUserDetailAPI(inputData, defaultParam = []) {
    this.checkAndGetLoginDetail();
    if (!this.partnerId) {
      this.partnerId = this.loginDetail && !inputData.partnerId ? this.loginDetail.partnerId : inputData.partnerId;
    }
    else {
      this.partnerId = inputData && inputData.partnerId >= 0   &&  inputData.partnerId !== null ? inputData.partnerId : this.partnerId;
    }
    inputData = this.checkAndInsertDetail('partnerId', inputData, this.partnerId, defaultParam);
    inputData = this.checkAndInsertDetail('userId', inputData, inputData.userId || this.loginDetail.userId, defaultParam);
    if (!inputData.profileId ) {
      inputData = this.checkAndInsertDetail('profileId', inputData, this.loginDetail.profileId, defaultParam);
    }
    return inputData;
  }

  getMethod(url, inputData) {
    const completeUrl = `${this.currentUrl}/api/` + url;
    this.notificationCount++;
    inputData = this.setUserDetailAPI(inputData);
    return this.http.get(completeUrl, { params: inputData }).pipe(catchError((err: HttpErrorResponse) => this.catchError(err)));
  }

  resetLoginDetail() {
    this.loginInfoProvider.clearLoginInfo();
    this.loginDetail = null;
  }

  returnPartnerId() {
    return this.partnerId;
  }

  catchError(errorObj: HttpErrorResponse) {
    if ((errorObj.error && errorObj.error.errorMessage || '').includes('Session Expired')) {
      this._commonDataSharedService.sessionExpired.next(true);
    }

    if (errorObj) {
      return observableThrowError(errorObj);
    }

  }
}
